<template>
  <nav class="navbar navbar-light navbar-expand">
    <a class="navbar-brand" href="/mypage">
      <img src="@/assets/image/logo.png" />
    </a>
    <button class="navbar-toggler collapsed" target="nav-collapse" />
    <div class="navbar-collapse collapse" id="nav-collapse" is-nav>
      <!-- Right aligned nav items -->
      <ul class="navbar-nav ms-auto">
        <chat-nav-item :chat-message-status="chatMessageStatus" />

        <li class="nav-item dropdown">
          <a
            id="dropdown-nemu"
            href="#"
            class="nav-link dropdown-toggle"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            @click="handleOpneDropdownMenu"
          >
            <template v-if="profile.icon !== null && profile.icon.url !== ''">
              <img :src="profile.icon.url" class="icon-user" />
            </template>
            <template v-else>
              <img src="@/assets/image/no-image.png" class="icon-user" />
            </template>
          </a>
          <ul class="dropdown-menu dropdown-menu-right" >
            <li>
              <a herf="#" class="dropdown-item disabled">
                <user-navigation-bar-item />
              </a>
            </li>
            <li>
              <a class="dropdown-item" v-for="(v, k) in menus" :key="k" :href="v.to">
                {{ $t(v.name) }}
              </a>
            </li>
            <li>
              <a class="dropdown-item" @click="logout">
                <img src="@/assets/image/icon-logout.png" class="icon-logout" />
                {{ $t('ログアウト') }}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>
<script lang="ts">
import { useNuxtApp } from 'nuxt/app';
import { defineComponent } from 'vue';
import { useUser } from '~/composables/user';
import { useCareerChat } from '~/composables/career/chats';
import UserNavigationBarItem from '~/components/models/user/UserNavigationBarItem.vue';
import ChatNavItem from '~/components/molecules/navbar/ChatNavItem.vue';

export default defineComponent({
  components: {
    UserNavigationBarItem,
    ChatNavItem
  },
  data() {
    const { profile } = useUser();
    const { state: chatState } = useCareerChat();

    return {
      profile,
      chatMessageStatus: chatState.value.chatMessageStatus,
      menus: [{ name: 'プロフィールを編集する', to: '/profile/edit' }]
    };
  },
  methods: {
    async logout() {
      const { $auth } = useNuxtApp();
      await $auth.logout();
      location.href = '/login';
    },
    handleOpneDropdownMenu() {
      const { showDropdown } = useBootstrap();
      showDropdown('dropdown-nemu');
    }
  }
});
</script>
<style lang="scss">
.navbar {
  background-color: #fff;
  border-bottom: 1px solid #f0f0f0;
  padding: 0.5rem 1rem;

  .navbar-brand > img {
    width: auto;
    height: 25px;
  }

  img.icon-user {
    width: 32px;
    height: 32px;
    object-fit: cover;
    border: 0;
    border-radius: 75px;
  }

  img.icon-cog {
    position: relative;
    top: -2px;
    width: 15px;
    height: 16px;
    margin-right: 10px;
  }

  img.icon-logout {
    position: relative;
    top: -2px;
    width: 15px;
    height: 14px;
    margin-right: 10px;
  }

  .dropdown-menu {
    min-width: 280px;
    font-size: 14px;
  }

  .dropdown-toggle em {
    display: inline-block;
    width: 32px;
    height: 32px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 16px;
  }

  .dropdown-toggle::after {
    display: none;
  }

  .dropdown-menu-right {
    right: 0;
    left: auto;
  }

  ul.dropdown-menu.dropdown-menu-right li a {
    padding: 15px 14px;
    border-bottom: 1px solid #f6f6f6;
  }
}
</style>
